import { render, staticRenderFns } from "./BaaUploadInputs.vue?vue&type=template&id=3a222ca4&scoped=true&"
import script from "./BaaUploadInputs.vue?vue&type=script&lang=js&"
export * from "./BaaUploadInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a222ca4",
  null
  
)

export default component.exports